import { render, staticRenderFns } from "./PasswordReqs.vue?vue&type=template&id=704fa6fd"
import script from "./PasswordReqs.vue?vue&type=script&lang=js"
export * from "./PasswordReqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports